import { ERROR_TYPES } from 'modules/event-manager/event-manager-error';
import { ERROR_KEYS } from 'constants/app.constants';
import { IFlowEventData } from 'types/analytics';

export const ERROR_TEXT_KEYS = {
    ERROR_MAINTENANCE: 'error-page__campaign-status-maintenance',
};

export const TEXT_KEYS = {
    MESSAGE: {
        [ERROR_TYPES.ERROR_MAINTENANCE]: ERROR_TEXT_KEYS.ERROR_MAINTENANCE,
        [ERROR_TYPES.NOT_ELIGIBLE]: ERROR_KEYS.WIDGET_ERROR_NOT_ELIGIBLE,
        [ERROR_TYPES.UNDERAGE]: ERROR_KEYS.WIDGET_ERROR_UNDERAGE,
        [ERROR_TYPES.SOMETHING_WRONG]: ERROR_KEYS.WIDGET_ERROR_MESSAGE
    }
};

export const ERROR_FLOW_STEP: Pick<IFlowEventData, 'flowStep'> = {
    flowStep: 'error'
};

export const ERROR_TRACKING_DETAILS = {
    [ERROR_TYPES.ERROR_MAINTENANCE]: 'maintenance',
    [ERROR_TYPES.SOMETHING_WRONG]: 'something went wrong',
    [ERROR_TYPES.NOT_ELIGIBLE]: 'not eligible',
    [ERROR_TYPES.UNDERAGE]: 'underage',
    [ERROR_TYPES.ALREADY_OPTED]: 'already opted-in'
};
